import { Component, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'fi-copy-clipboard',
  templateUrl: './copy.component.html',
  styleUrls: ['./copy.component.scss'],
  standalone: false,
})
export class CopyComponent implements OnDestroy {

  @Input() copyText: string = '';
  @Input() small: boolean = false;

  showSuccess: boolean = false;

  private timeout: ReturnType<typeof setTimeout> | undefined;

  copyToClipboard(): void {
    if ( !this.copyText || !navigator?.clipboard?.writeText ) {
      return;
    }

    navigator.clipboard.writeText(this.copyText).then(() => {
      this.showSuccess = true;

      if ( this.timeout ) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
    }).catch(err => {
      console.error('Clipboard copy failed:', err);
    });
  }

  ngOnDestroy(): void {
    if ( this.timeout ) {
      clearTimeout(this.timeout);
    }
  }

}
